import PropTypes from 'prop-types'
import React from "react";
import styled from "styled-components";

import TypographyParagraph from "../../../../../TypographyParagraph";
import InfoIcon from "../../../../../icons/InfoIcon";
import Tooltip from "../../../../../Tooltip";

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;
const Title = styled((props) => <TypographyParagraph {...props}/>)`
  flex: 1 1 100%;
  font-size: 16;
  color: ${(props) => props.theme.primaryLight};
  font-weight: 500;
  margin-top: 14px !important;
  margin-right: 4px;
`;
const Icon = styled((props) => <InfoIcon {...props}/>)`
  color: #908f90;
`;
const ShareReportDialogSubhead = ({ label, metaLabel }) => (
  <Wrapper>
    <Title>{label}</Title>
    <Tooltip title={metaLabel} placement="right-start">
      <span>
        <Icon />
      </span>
    </Tooltip>
  </Wrapper>
);

ShareReportDialogSubhead.propTypes = {
  /** Subheading label */
  label: PropTypes.oneOf([ 'Inherited Access', 'Shared Directly' ]),
  /** Subheading tooltip content */
  metaLabel: PropTypes.string,
};
export default ShareReportDialogSubhead;



// WEBPACK FOOTER //
// ./src/components/SRHHeaders/SummaryReportHeader/components/ShareReport/components/DialogSubhead.jsx